var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import _uniqBy from 'lodash/uniqBy';
import { withTranslation } from "react-i18next";
import { Timeline } from "../timeline";
import { OrderStatusBackground } from "../elements/order.status";
import { FaCheckCircle, FaBan } from "react-icons/fa";
let OrderTimelineClass = class OrderTimelineClass extends React.Component {
    render() {
        const { t, status, isDelivery, isBooking } = this.props;
        if (status === "cancelled" ||
            status === "complete" ||
            (isBooking && status === "seated")) {
            const labelKey = isBooking && status === "seated"
                ? "booking.status.seated"
                : `order.status.${status}`;
            return (React.createElement(OrderStatusBackground, { status: status, className: "p-tb-3 p-lr-5 text-center flex-center" },
                React.createElement("h4", null,
                    (status === "complete" || status === "seated") && (React.createElement(FaCheckCircle, { className: "m-r-2" })),
                    status !== "complete" && status !== "seated" && (React.createElement(FaBan, { className: "m-r-2" }))),
                React.createElement("h4", null, t(labelKey, { defaultValue: "Seated" }))));
        }
        let stages = [];
        let defaultStages = [
            { id: "confirmed", label: t("order.status.confirmed") },
            { id: "ready", label: t("order.status.ready") },
            { id: "on_route", label: t("order.status.on_route") },
        ];
        if (status === "unconfirmed" || status === "awaiting_payment") {
            let beforeConfirmed = { id: "unconfirmed", label: t("order.status.unconfirmed") };
            if (status === "awaiting_payment")
                beforeConfirmed = { id: "awaiting_payment", label: t("order.status.awaiting_payment") };
            stages = [beforeConfirmed, ...defaultStages];
        }
        else {
            stages = defaultStages;
        }
        stages = _uniqBy(stages, 'id');
        if (isBooking) {
            stages = [
                { id: "unconfirmed", label: t("order.status.unconfirmed") },
                { id: "confirmed", label: t("order.status.confirmed") },
            ];
        }
        else if (!isDelivery) {
            stages.splice(stages.length - 1, 1);
        }
        return (React.createElement(Timeline, { stages: stages, current: status }));
    }
};
OrderTimelineClass = __decorate([
    observer
], OrderTimelineClass);
export const OrderTimeline = withTranslation()(OrderTimelineClass);
//# sourceMappingURL=timeline.js.map